var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53125 3.28116L9.96484 3.74991L10.4336 3.28194C11.7422 2.00655 13.5547 1.42608 15.3359 1.72257C18.0273 2.17101 20 4.49991 20 7.23038V7.45694C20 9.07804 19.3281 10.6288 18.1406 11.7343L11.082 18.3241C10.7891 18.5976 10.4023 18.7499 10 18.7499C9.59766 18.7499 9.21094 18.5976 8.91797 18.3241L1.85898 11.7343C0.673047 10.6288 0 9.07804 0 7.45694V7.23038C0 4.49991 1.97344 2.17101 4.66406 1.72257C6.41016 1.42608 8.25781 2.00655 9.53125 3.28116Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveLike);
export default __webpack_public_path__ + "static/media/activeLike.353f8b40e3e14f752a0c65ffe4d6ddb8.svg";
export { ForwardRef as ReactComponent };